/**
 * @file        src/lib/company.js
 * @description Issuing-company details printed on customer documents (tax
 *              invoice, voucher) and shown on the legal / contact pages. The
 *              postal ADDRESS here is only the FALLBACK — the live value comes
 *              from admin Site Settings via useCompanyInfo(); see that hook.
 *              Extracted from pages/Legal/LegalDoc.jsx (which re-exports it),
 *              mirroring the neon build's lib/company.js, so the hook can
 *              import the defaults without a circular import and the Contact
 *              page (CR A4) reads the same single-source address as the legal
 *              documents / invoice / voucher instead of a third hardcoded copy.
 * @author      Kinetika Labs
 * @created     2026-08-04
 * @changelog
 *   - 2026-10-23 PG — Client-supplied registration details: legal name
 *                      "Beyond Destination" (was "… Pvt. Ltd."), GSTIN
 *                      27BBPPK9113H1ZD and its PAN, address as registered
 *                      (with "Sq,"), and the mobile numbers in their order.
 *   - 2026-08-04 Claude — Extracted from LegalDoc.jsx (ported the neon
 *                          pattern). Address corrected to match the Contact
 *                          page's copy (dropped a stray "Sq," that had crept
 *                          into LegalDoc's string — the Contact page's address
 *                          was the more recently verified one, see its
 *                          2026-07-31 "Get directions" changelog entry).
 *   - 2026-09-15 Claude — `gstin` / `state` are no longer the live values, only
 *     the fallbacks: both now come from admin Site Settings via useCompanyInfo()
 *     (admin migration 056), which is what finally lets a tenant put its real
 *     GSTIN on its tax invoices. The "replace before go-live" TODO below is
 *     therefore answered by configuration, not by editing this file — and the
 *     placeholders stay deliberately neutral so an unconfigured tenant prints
 *     nothing rather than another tenant's registration.
 */
export const COMPANY = {
  name: 'Beyond Destination',
  // Registered name on the GST certificate (client, 2026-10-23).
  legal: 'Beyond Destination',
  // Fallback address only — the live value is the one configured in admin Site
  // Settings (Site Management → Site Setting), fetched by useCompanyInfo().
  address: 'Shop No 04, Gurudarshan Complex, Central Ave, Chapru Nagar, Sq, Nagpur, Maharashtra 440008',
  email: 'info@beyonddestination.in',
  phone: '+91 - 9372502300 | 9371502300',
  support: 'info@beyonddestination.in',
  web: 'www.beyonddestination.in',
  jurisdiction: 'Nagpur, Maharashtra',
  // FALLBACKS ONLY — the live values come from admin Site Settings (Payment
  // Management → Tax Management) via useCompanyInfo(). These are Beyond
  // Destination's own registration (client, 2026-10-23); this bundle is only
  // ever built for the Beyond brand. PAN is characters 3–12 of the GSTIN.
  state: 'Maharashtra',
  gstin: '27BBPPK9113H1ZD',
  pan: 'BBPPK9113H',
  registrationNo: '—',
  hsn: '—',
};
